"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastDragSelector = void 0;
function getLastDragSelector(state) {
    return state.interactions.pointer.lastDrag;
}
exports.getLastDragSelector = getLastDragSelector;
//# sourceMappingURL=get_last_drag.js.map